import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { WhatWeDo } from "./components/WhatWeDo";
import { WhyWebsite } from "./components/WhyWebsite";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        lenisRef.current = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    const navigate = (hash) => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenisRef.current) {
            lenisRef.current.scrollTo(el, { offset: -56 });
        } else {
            el.scrollIntoView();
        }
    };

    return (
        <div className="App">
            <Navbar onNavigate={navigate} />
            <main>
                <Hero />
                <Marquee />
                <WhatWeDo />
                <WhyWebsite />
                <Contact />
            </main>
            <Footer onNavigate={navigate} />
        </div>
    );
}

export default App;
